
/**
 * 응답 데이터
 */
export type NicePayPaymentCallback200Data = { [key: string]: unknown };
